import * as React from "react";

import {Label} from "semantic-ui-react";
import {translate} from "react-i18next";
// redux
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";

// components
import Button from "../../../components/Button";
import {Dialog} from "../../../components/Dialogs/Dialog";
import SelectField from "../../../components/SelectField";
import {PSLChangeWorkflowParam} from "../../../components/Table/VirtualizedTableInterfaces";

// dtos
import {WorkflowDto} from "../../../services/Client";
import {sortWorkflowsByName} from "../../../services/WorkflowUtils";

interface IChangeWorkflowOptionDlgProps extends ITranslatedComponent {
    changeOptionWorkflowParam: PSLChangeWorkflowParam;

    // actions
    onClose: () => void;
    onSave: (newVal: string) => void;
}

interface IChangeWorkflowOptionDlgState {
    selectedWorkflow?: WorkflowDto;
}

class ChangeWorkflowOptionDlg extends React.Component<IChangeWorkflowOptionDlgProps, IChangeWorkflowOptionDlgState> {

    constructor(props: IChangeWorkflowOptionDlgProps) {
        super(props);

        this.state = {
            selectedWorkflow: undefined
        };
    }

    private onSave = () => {
        if (this.state.selectedWorkflow) {
            const firstStep = this.state.selectedWorkflow.status ? this.state.selectedWorkflow.status.find((step) => step.sequenceNumber === 0) : undefined;

            if(firstStep) {
                const newStatus = this.state.selectedWorkflow.objectId + '_' + firstStep.objectId;
                this.props.onSave(newStatus);
            }
        }
    }

    render() {
        const {t, changeOptionWorkflowParam: {value, workflows}} = this.props;

        const currentWorkflowId = value.dto.status.split('_')[0];
        const currentWorkflow = value.workflows.find((wf) => wf.objectId.toString() === currentWorkflowId);
        const selectionWorkflows = workflows.filter((wf) => wf.objectId.toString() !== currentWorkflowId).sort(sortWorkflowsByName);

        let actions = selectionWorkflows.length > 0 ? [
            (
                <Button
                    key={"submitButton"}
                    icon={"checkmark"}
                    disabled={this.state.selectedWorkflow === undefined}
                    onClick={this.onSave}
                />
            )
        ] : [];
        actions.push(
            <Button
                key={"cancelButton"}
                icon={"ban"}
                onClick={this.props.onClose}
            />
        );

        return (
            <Dialog
                title={t("CHANGE_WF_TITLE")}
                open={true}
                actions={actions}
            >
                <div>
                    {t("CHANGE_WF_TXT")}
                    <Label size={'medium'} className={'whitespace--nowrap'}>
                        {
                            // @ts-ignore
                            value.dto.optionBasic.optionCode
                        }
                        <Label.Detail>
                            {
                                // @ts-ignore
                                value.dto.optionBasic.optionType
                            }
                        </Label.Detail>
                    </Label>
                </div>

                <div style={{margin: '20px 0px 15px'}}>
                    <span className={'psl-change-wf-header'}>
                        {t("CURRENT_WORKFLOW")}
                    </span>
                    <SelectField
                        readonly={true}
                        dataSource={value.workflows}
                        value={currentWorkflow}
                        rendererKey={(wf: WorkflowDto) => wf.name}
                    />
                </div>

                {selectionWorkflows.length > 0 ?
                    <>
                        <span className={'psl-change-wf-header'}>
                            {t("NEW_WORKFLOW")}
                        </span>
                        <SelectField
                            placeholder={t("SELECT_NEW_WORKFLOW")}
                            clearable={true}
                            searchable={true}
                            dataSource={selectionWorkflows}
                            value={this.state.selectedWorkflow}
                            rendererKey={(wf: WorkflowDto) => wf.name}
                            onChange={(selectedWorkflow: WorkflowDto) => this.setState({selectedWorkflow})}
                        />
                    </>
                    :
                    <span className={'psl-change-wf-header color--red'}>
                        {t("EMPTY_WF_LIST")}
                    </span>
                }
            </Dialog>
        );
    }
}

export default translate(["PSL_WF_CHANGE"])(ChangeWorkflowOptionDlg);



// WEBPACK FOOTER //
// ./src/views/OptionsView/workflowChange/ChangeWorkflowOptionDlg.tsx